/* eslint-disable react-refresh/only-export-components */
import { useEffect, useState } from 'react';

import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';

/**
 * Shared utility functions and components for credential sections
 */

/** Convert camelCase to Title Case with spaces */
export const unCamelize = (text: string): string =>
  text.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());

/** Check if a field name should be a password input */
export const isPasswordFieldName = (fieldName: string): boolean => {
  const lower = fieldName.toLowerCase();
  return lower === 'password' || lower === 'passphrase' || lower.includes('secret');
};

/** Format bytes to human-readable (matches formatBytes in flatfile.js) */
export const formatBytes = (bytes: number | string | null | undefined, decimals = 2): string => {
  const n = typeof bytes === 'number' ? bytes : Number(bytes);
  if (n === 0 || Number.isNaN(n) || n < 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(n) / Math.log(k));
  return `${parseFloat((n / Math.pow(k, i)).toFixed(decimals))} ${sizes[i]}`;
};

/** Connection check result icons (matches EnvCheckIcons in index.js) */
export const EnvCheckIcons = ({ result }: { result: string | null }) => {
  if (!result) return null;
  return result === '200 OK' ? (
    <CheckCircleIcon sx={{ color: '#019644', fontSize: 24, verticalAlign: 'middle' }} />
  ) : (
    <ErrorIcon sx={{ color: '#D40000', fontSize: 24, verticalAlign: 'middle' }} />
  );
};

/** Animated loading dots */
export const AnimatedDots = ({ text }: { text: string }) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 15 ? `${prev}.` : ''));
    }, 200);
    return () => clearInterval(interval);
  }, []);

  return (
    <span>
      {text}
      {dots}
    </span>
  );
};
